<script>
  import { pop } from "svelte-spa-router";

  import { popup } from "../stores.js";
</script>

<div class="overlay" on:mousedown={pop}>
  <div class="bg" on:mousedown|stopPropagation>
    <div class="msg">
      {$popup.msg}
    </div>
    <div class="buttons">
      <div class="button no" on:click|stopPropagation={pop}>ביטול</div>
      <div
        class="button yes"
        on:click|stopPropagation={() => {
          $popup.callback();
          pop();
        }}
      >
        אישור
      </div>
    </div>
  </div>
</div>

<style>
  .overlay {
    background: #0008;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 8;
  }

  .bg {
    background: white;
    border-radius: 4px;
    width: 100%;
    max-width: 310px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 18px;
    padding: 10px;
  }

  .msg {
    padding: 20px;
    direction: rtl;
  }

  .buttons {
    display: flex;
  }

  .button {
    padding: 14px 45px;
    color: white;
    margin: 4px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    cursor: pointer;
  }

  .yes {
    background: var(--green1);
  }
  .no {
    background: var(--red1);
  }
</style>
